import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from 'antd'
import { LocalStorageService } from '../../services'
import i18nextConfig from '../../config/i18next'
import axios from 'axios'
import apiConfig from '../../config/api'

import iconLangEsCl from '../../layouts/Private/components/Footer/assets/lang-es.png'
import iconLangEsPe from '../../layouts/Private/components/Footer/assets/lang-es-pe.png'
import iconLangPt from '../../layouts/Private/components/Footer/assets/lang-pt.png'
import iconLangBr from '../../layouts/Private/components/Footer/assets/lang-br.png'
import iconLangEn from '../../layouts/Private/components/Footer/assets/lang-en.png'
import logoAml from '../../layouts/Private/components/Footer/assets/logo-aml.png'
import ImageResources from "../../layouts/commonComponent/components/ExternalResources/ImageResources"

const Footer = ({country, client}) => {
    const { t } = useTranslation()
    const lang = i18nextConfig.language
    const [language, setLanguage] = useState(lang)
    const [theme, setTheme] = useState('theme-metal')
    const [hasBanner, setHasBanner] = useState(false)
    const [checkingBanner, setCheckingBanner] = useState(true)

    useEffect(() => {
        let theme = LocalStorageService.read('theme')

        if(country) {
            const language = i18nextConfig.language
            i18nextConfig.changeLanguage(language.substring(0, 2) + country)
        }

        if (theme === null) {
            theme = 'theme-metal'
            LocalStorageService.create('theme', theme)
        }
        setTheme(theme)
        document.body.className = theme
	}, [country])

    useEffect(() => {
        if (client && client.id) {
            setCheckingBanner(true)
            const bannerUrl = apiConfig.url + `/portal/getLogoFooterPortal/${client.id}`
            axios.get(bannerUrl, {
                responseType: 'arraybuffer'
            })
                .then(response => {
                    if(response.data !== null && response.data !== '' && response.data.byteLength > 500) {
                        // Si la imagen es mayor a 500 bytes, consideramos que hay un banner real
                        setHasBanner(true)
                    } else {
                        // Si es menor o igual a 500 bytes, es una imagen vacía
                        setHasBanner(false)
                    }
                })
                .catch(error => {
                    setHasBanner(false)
                })
                .finally(() => {
                    setCheckingBanner(false)
                })
        } else {
            setHasBanner(false)
            setCheckingBanner(false)
        }
    }, [client])

    const handleThemeChange = (e, themeClassName) => {
        e.preventDefault()

        setTheme(themeClassName)

        document.body.className = themeClassName

        LocalStorageService.update('theme', themeClassName)
    }

    const handleLanguageChange = async (lng) => {    
        let language = lng + country
        setLanguage(language)
        i18nextConfig.changeLanguage(language)
    }

    // Si hay banner, mostrar el diseño actual
    if (hasBanner) {
        return (
            <div id="footer">
                <div className="footer-inner">
                    <div className="footer-banner-container">
                        <div className="footer-banner">
                            {client && (
                                <ImageResources 
                                    url={`/portal/getLogoFooterPortal/${client.id}`}
                                    styleResource={{ height: '120px', maxWidth: '900px', objectFit: 'contain' }}
                                />
                            )}
                            <div className="powered">
                                <span>Powered by <a href="https://www.gesintel.cl" target="_blank">Gesintel Compliance S.A.</a></span>
                            </div>
                        </div>
                    </div>
                    <div className="footer-theme-container">
                        <div className="footer-theme-wrapper">
                            <div className="h3-wrapper">
                                <h3>{ t('messages.aml.themeSelector') }</h3>
                            </div>
                            <ul className="selector">
                                <li className={ theme === 'theme-metal' ? 'selected' : '' } onClick={ (e) => handleThemeChange(e, 'theme-metal') }>
                                    <a href="#">
                                        <div className="theme-color" style={{ backgroundColor: '#c9c7c7' }}></div>
                                        <span>Metal</span>
                                        { theme === 'theme-metal' && <Icon type="check" /> }
                                    </a>
                                </li>
                                <li className={ theme === 'theme-sepia' ? 'selected' : '' } onClick={ (e) => handleThemeChange(e, 'theme-sepia') }>
                                    <a href="#">
                                        <div className="theme-color" style={{ backgroundColor: '#cebb7d' }}></div>
                                        <span>{ t('messages.aml.themes.sepia') }</span>
                                        { theme === 'theme-sepia' && <Icon type="check" /> }
                                    </a>
                                </li>
                                <li className={ theme === 'theme-ice' ? 'selected' : '' } onClick={ (e) => handleThemeChange(e, 'theme-ice') }>
                                    <a href="#">
                                        <div className="theme-color" style={{ backgroundColor: '#c6dbf4' }}></div>
                                        <span>{ t('messages.aml.themes.ice') }</span>
                                        { theme === 'theme-ice' && <Icon type="check" /> }
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-language-container">
                        <div className="footer-language-wrapper">
                            <div className="h3-wrapper">
                                <h3>{ t('messages.aml.languageSelector') }</h3>
                            </div>
                            <ul className="selector langs">
                                <li className={ language.startsWith('es') ? 'selected' : '' } onClick={ () => handleLanguageChange('es') }>
                                    <img className="language-icon" src={ country === 'PER' ? iconLangEsPe : iconLangEsCl } alt="" />
                                    <span>Español { country === 'PER' && <span>( Perú )</span> }</span>
                                    <Icon type="check" />
                                </li>
                                <li className={ language.startsWith('en') ? 'selected' : '' } onClick={ () => handleLanguageChange('en') }>
                                    <img className="language-icon"  src={ iconLangEn } alt="" />
                                    <span>English</span>
                                    <Icon type="check" />
                                </li>
                                <li className={ language.startsWith('pt') ? 'selected' : '' } onClick={ () => handleLanguageChange('pt') }>
                                    <img className="language-icon"  src={ iconLangBr } alt="" />
                                    <span>Portugués - Br</span>
                                    <Icon type="check" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // Si no hay banner, mostrar el footer como en amlupdate v2 (con logo AML)
    return (
        <div id="footer">
            <div className="footer-inner footer-no-banner">
                <div className="footer-logo-container">
                    <div className="footer-logo-wrapper">
                        <img className="logo" src={logoAml} alt="" />
                        <div className="powered">
                            <span>Powered by <a href="https://www.gesintel.cl" target="_blank">Gesintel Compliance S.A.</a></span>
                        </div>
                    </div>
                </div>
                <div className="footer-theme-container">
                    <div className="footer-theme-wrapper">
                        <div className="h3-wrapper">
                            <h3>{ t('messages.aml.themeSelector') }</h3>
                        </div>
                        <ul className="selector">
                            <li className={ theme === 'theme-metal' ? 'selected' : '' } onClick={ (e) => handleThemeChange(e, 'theme-metal') }>
                                <a href="#">
                                    <div className="theme-color" style={{ backgroundColor: '#c9c7c7' }}></div>
                                    <span>Metal</span>
                                    { theme === 'theme-metal' && <Icon type="check" /> }
                                </a>
                            </li>
                            <li className={ theme === 'theme-sepia' ? 'selected' : '' } onClick={ (e) => handleThemeChange(e, 'theme-sepia') }>
                                <a href="#">
                                    <div className="theme-color" style={{ backgroundColor: '#cebb7d' }}></div>
                                    <span>{ t('messages.aml.themes.sepia') }</span>
                                    { theme === 'theme-sepia' && <Icon type="check" /> }
                                </a>
                            </li>
                            <li className={ theme === 'theme-ice' ? 'selected' : '' } onClick={ (e) => handleThemeChange(e, 'theme-ice') }>
                                <a href="#">
                                    <div className="theme-color" style={{ backgroundColor: '#c6dbf4' }}></div>
                                    <span>{ t('messages.aml.themes.ice') }</span>
                                    { theme === 'theme-ice' && <Icon type="check" /> }
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-language-container">
                    <div className="footer-language-wrapper">
                        <div className="h3-wrapper">
                            <h3>{ t('messages.aml.languageSelector') }</h3>
                        </div>
                        <ul className="selector langs">
                            <li className={ language.startsWith('es') ? 'selected' : '' } onClick={ () => handleLanguageChange('es') }>
                                <img className="language-icon" src={ country === 'PER' ? iconLangEsPe : iconLangEsCl } alt="" />
                                <span>Español { country === 'PER' && <span>( Perú )</span> }</span>
                                <Icon type="check" />
                            </li>
                            <li className={ language.startsWith('en') ? 'selected' : '' } onClick={ () => handleLanguageChange('en') }>
                                <img className="language-icon"  src={ iconLangEn } alt="" />
                                <span>English</span>
                                <Icon type="check" />
                            </li>
                            <li className={ language.startsWith('pt') ? 'selected' : '' } onClick={ () => handleLanguageChange('pt') }>
                                <img className="language-icon"  src={ iconLangBr } alt="" />
                                <span>Portugués - Br</span>
                                <Icon type="check" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer